// extracted by mini-css-extract-plugin
export var breedlistinner = "SectionBreedList-module--breedlistinner--105c8";
export var breedlistouter = "SectionBreedList-module--breedlistouter--d6d9f";
export var textWrapper = "SectionBreedList-module--textWrapper--9603f";
export var title = "SectionBreedList-module--title--d2ee1 headings-module--sectionHeading--a8f67";